import { IconArrowDown } from "@decibeltrade/react-icons";
import { Button } from "@decibeltrade/web-core/components";
import { useLocale, useTranslations } from "next-intl";
import { css } from "styled-system/css";

import { NumberFormatter } from "@/utils/number-formatter";

import { bannerAmountStyles, bannerCardStyles, bannerLabelStyles } from "./banner-card-styles";

interface ReadyToClaimCardProps {
  count: number;
  totalUsd: number;
  onClaimAll: () => void;
  isClaimingAll?: boolean;
  disabled?: boolean;
}

export function ReadyToClaimCard({
  count,
  totalUsd,
  onClaimAll,
  isClaimingAll = false,
  disabled = false,
}: ReadyToClaimCardProps) {
  const t = useTranslations("rewards");
  const locale = useLocale();

  return (
    <div className={bannerCardStyles}>
      <div className={bannerLabelStyles}>{t("banner.readyToClaim")}</div>
      <div className={bannerAmountStyles}>
        {NumberFormatter.compactHeading(totalUsd, { currency: true, locale })}
      </div>
      {count > 0 && <div className={subLabelStyles}>{t("banner.claimsAwaiting", { count })}</div>}
      <Button
        variant="secondary"
        size="md"
        disabled={count === 0 || disabled}
        TailIcon={IconArrowDown}
        onClick={onClaimAll}
        className={css({ mt: "16", alignSelf: "flex-start" })}
      >
        {isClaimingAll ? t("toast.claimAllInProgress") : t("banner.claimAll")}
      </Button>
    </div>
  );
}

const subLabelStyles = css({ mt: "16", textStyle: "highlight.md", color: "text.disabled" });
